/**
 * Yields today and tomorrow's javascript date objects.
 * Encapsulating this functionality allows much easier testing and necessary mocking as well as reuse if needed.
 *
 * @private
 * @returns {{ todayDate: object, tomorrowDate: object }} - javascript date objects pertaining to today and tomorrow's date
 */
export default (function () {
  var todayDate = new Date();
  var tomorrowDate = new Date();
  tomorrowDate.setDate(tomorrowDate.getDate() + 1);
  return {
    todayDate: todayDate,
    tomorrowDate: tomorrowDate
  };
});